var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistProgramTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.186 42.406c-.047 0-.095-.003-.144-.01a19.84 19.84 0 0 1-6.513-2.132 1.001 1.001 0 0 1 .942-1.766 17.78 17.78 0 0 0 5.856 1.917 1.001 1.001 0 0 1-.141 1.991zM49.814 42.406a1 1 0 0 1-.141-1.99 17.773 17.773 0 0 0 5.856-1.917 1.002 1.002 0 0 1 .942 1.766 19.84 19.84 0 0 1-6.513 2.132 1.184 1.184 0 0 1-.144.009zM39.354 33.429a.998.998 0 0 1-.837-1.546 7.622 7.622 0 0 1 6.405-3.471 1 1 0 1 1 0 2 5.624 5.624 0 0 0-4.729 2.563.997.997 0 0 1-.839.454z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.139 30.412c-3.545 0-6.539-2.994-6.539-6.538s2.994-6.538 6.539-6.538c3.544 0 6.538 2.994 6.538 6.538s-2.994 6.538-6.538 6.538zm0-11.076c-2.46 0-4.539 2.078-4.539 4.538s2.079 4.538 4.539 4.538 4.538-2.078 4.538-4.538-2.078-4.538-4.538-4.538z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 37.059a1 1 0 0 1-1-1 5.653 5.653 0 0 0-5.646-5.646 1 1 0 1 1 0-2c4.216 0 7.646 3.431 7.646 7.646a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.354 30.412h-4.431a1 1 0 1 1 0-2h4.431a1 1 0 1 1 0 2zM56 40.382a1 1 0 0 1-1-1v-3.323a1 1 0 1 1 2 0v3.323a1 1 0 0 1-1 1zM20.185 41.12a1 1 0 0 1-1-1c0-5.438 4.424-9.861 9.861-9.861a1 1 0 1 1 0 2c-4.335 0-7.861 3.526-7.861 7.861a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.954 32.259h-5.908a1 1 0 1 1 0-2h5.908a1 1 0 1 1 0 2zM24.646 33.429a1 1 0 0 1-.839-.454 5.627 5.627 0 0 0-4.729-2.563 1 1 0 1 1 0-2 7.62 7.62 0 0 1 6.405 3.471 1 1 0 0 1-.837 1.546zM20.185 45.551a1 1 0 0 1-1-1V40.12a1 1 0 1 1 2 0v4.431a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32.259c-4.545 0-8.385-3.84-8.385-8.385s3.84-8.385 8.385-8.385 8.385 3.84 8.385 8.385-3.84 8.385-8.385 8.385zm0-14.77c-3.461 0-6.385 2.924-6.385 6.385s2.924 6.385 6.385 6.385 6.385-2.924 6.385-6.385-2.924-6.385-6.385-6.385z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.815 41.12a1 1 0 0 1-1-1c0-4.335-3.526-7.861-7.861-7.861a1 1 0 1 1 0-2c5.438 0 9.861 4.424 9.861 9.861a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.815 45.551a1 1 0 0 1-1-1V40.12a1 1 0 1 1 2 0v4.431a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48.511c-4.22 0-8.439-1.026-12.286-3.077a1.002 1.002 0 0 1 .942-1.766 24.065 24.065 0 0 0 22.689 0 1.002 1.002 0 0 1 .942 1.766A26.112 26.112 0 0 1 32 48.511zM16.861 30.412c-3.544 0-6.538-2.994-6.538-6.538s2.994-6.538 6.538-6.538 6.538 2.994 6.538 6.538-2.994 6.538-6.538 6.538zm0-11.076c-2.46 0-4.538 2.078-4.538 4.538s2.078 4.538 4.538 4.538 4.538-2.078 4.538-4.538-2.078-4.538-4.538-4.538z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 37.059a1 1 0 0 1-1-1c0-4.216 3.431-7.646 7.646-7.646a1 1 0 1 1 0 2A5.651 5.651 0 0 0 9 36.059a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.077 30.412h-4.431a1 1 0 1 1 0-2h4.431a1 1 0 1 1 0 2zM8 40.382a1 1 0 0 1-1-1v-3.323a1 1 0 1 1 2 0v3.323a1 1 0 0 1-1 1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistProgramTeam);
export default __webpack_public_path__ + "static/media/assist-program-team.fb0a754b7e5e54c5f2fece3bf3cbb75a.svg";
export { ForwardRef as ReactComponent };